"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeContext = void 0;
const React = require("react");
/**
 * Provides the chosen order type for the ordering app
 */
exports.OrderTypeContext = React.createContext({
    orderType: undefined,
    setOrderType: undefined,
    resetOrderType: undefined
});
//# sourceMappingURL=index.js.map